import React from "react";
import Dashboard from "../components/Dashboard";
import MainLayout from "../components/Layouts";

const DashboardPage = () => {
  return (
    <MainLayout>
      <Dashboard />
    </MainLayout>
  );
};

export default DashboardPage;
 